<div class="page-container list-page-container" testId="tenant-contact-page-container">
  <div class="page-topbar header-section" testId="tenant-contact-header-section">
    <div class="page-header header-main" testId="tenant-contact-header-main">
      <div class="page-heading title-section" testId="tenant-contact-title-section">
        <h3 class="page-title" testId="tenant-contact-title">{{ pageTitleKey | i18n }}</h3>
      </div>
    </div>
    <div class="topbar-search" testId="tenant-contact-toolbar-row">
      <div class="topbar-search-row has-controls" testId="tenant-contact-search-container">
        <button
          nz-button
          nzType="default"
          type="button"
          class="search-toggle"
          [class.is-active]="mobileSearchExpanded || !!trimmedKey"
          (click)="toggleMobileSearch()"
          testId="tenant-contact-mobile-search-toggle"
        >
          <i nz-icon [nzType]="mobileSearchExpanded ? 'close' : 'search'"></i>
        </button>

        <nz-input-group
          [nzSuffix]="suffixIconSearch"
          class="search-input"
          [class.mobile-expanded]="mobileSearchExpanded || !!trimmedKey"
          testId="tenant-contact-search-input-group"
        >
          <input
            #searchInputElement
            type="text"
            nz-input
            [(ngModel)]="key"
            [placeholder]="'common.search.placeholder' | i18n"
            (keyup.enter)="onSearch()"
            testId="tenant-contact-search-input"
          />
          <ng-template #suffixIconSearch>
            <i
              nz-icon
              nzType="search"
              (click)="onSearch()"
              class="search-icon"
              nz-tooltip
              [nzTooltipTitle]="'common.search' | i18n"
              testId="tenant-contact-search-icon"
            ></i>
          </ng-template>
        </nz-input-group>

        <div class="toolbar-controls">
          <button
            nz-button
            nzType="default"
            type="button"
            class="reset-button"
            (click)="resetSearch()"
            [disabled]="!trimmedKey"
            nz-tooltip
            [nzTooltipTitle]="'common.clear' | i18n"
            testId="tenant-contact-reset-btn"
          >
            <i nz-icon nzType="clear"></i>
            <span class="reset-button-text" *ngIf="!isMobileView">{{ 'common.clear' | i18n }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="page-scroll" #mobileScrollContainer testId="tenant-contact-page-scroll">
    <div class="result-meta" testId="tenant-contact-result-meta">
      <div class="result-count" testId="tenant-contact-pagination-info">{{ 'common.total-records' | i18n: { total: total } }}</div>
      <button
        *ngIf="trimmedKey"
        nz-button
        nzType="link"
        type="button"
        class="clear-filters-inline"
        (click)="resetSearch()"
        testId="tenant-contact-clear-filters-btn"
      >
        {{ 'servicenumber.clear-filter' | i18n }}
      </button>
    </div>

    <div class="content-section" testId="tenant-contact-table-section">
      <nz-spin [nzSpinning]="loading">
        <div class="table-section">
          <div class="filter-strip" *ngIf="trimmedKey" testId="tenant-contact-filter-section">
            <div class="filter-tags">
              <nz-tag
                *ngIf="trimmedKey"
                nzMode="closeable"
                [nzColor]="'blue'"
                (nzOnClose)="clearFilter('keywords')"
                testId="tenant-contact-filter-keywords-tag"
              >
                {{ 'common.name' | i18n }}: {{ trimmedKey }}
              </nz-tag>
            </div>
          </div>

          <nz-table
            #contactTable
            class="table-container fixed-header-table"
            nzSize="middle"
            [nzScroll]="embeddedMode ? { x: '960px' } : { x: '960px', y: '100%' }"
            [nzData]="listOfData"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            testId="tenant-contact-table"
          >
            <thead testId="tenant-contact-table-head">
              <tr testId="tenant-contact-table-header-row">
                <th scope="col" nzWidth="60px" class="text-center row-number-column" testId="tenant-contact-table-header-serial">
                  {{ 'common.serial-number' | i18n }}
                </th>
                <th scope="col">{{ 'common.avatar' | i18n }}</th>
                <th scope="col">{{ 'common.name' | i18n }}</th>
                <th scope="col">{{ 'tenant.contact.channel' | i18n }}</th>
                <th scope="col">{{ 'common.phone' | i18n }}</th>
                <th scope="col">{{ 'common.status' | i18n }}</th>
                <th scope="col" class="table-actions-header">{{ 'common.actions' | i18n }}</th>
              </tr>
            </thead>
            <tbody testId="tenant-contact-table-body">
              <tr
                *ngFor="let item of contactTable.data; let i = index; trackBy: trackByContact"
                [testId]="'tenant-contact-table-row-' + item.id"
              >
                <td class="text-center row-number-column" [testId]="'tenant-contact-table-cell-serial-' + item.id">{{ i + 1 }}</td>
                <td>
                  <nz-avatar [nzSrc]="item.avatarUrl || item.fallbackAvatarUrl" nzShape="circle" nzSize="small" />
                </td>
                <td>
                  <div class="name-cell">
                    <div class="name">{{ getDisplayName(item) }}</div>
                    <div class="alias" *ngIf="item.alias && item.alias !== item.name">{{ item.alias }}</div>
                  </div>
                </td>
                <td>
                  <span class="channel-pill">{{ item.channel || ('common.unknown' | i18n) }}</span>
                </td>
                <td>
                  {{ item.phone || '-' }}
                </td>
                <td>
                  <span class="status-pill" [ngClass]="getStatusPillClass(item.status)">{{ getStatusTextKey(item.status) | i18n }}</span>
                </td>
                <td class="table-actions-cell">
                  <div class="table-actions">
                    <button
                      *ngIf="item?.id"
                      nz-button
                      nzType="link"
                      class="table-action-btn table-action-view"
                      (click)="openDetail(item)"
                      [testId]="'tenant-contact-view-btn-' + i"
                    >
                      {{ 'common.view' | i18n }}
                    </button>
                    <a
                      nz-popconfirm
                      nzPopconfirmTitle="{{ 'tenant.contact.clean.confirm' | i18n }}"
                      nzOkText="{{ 'common.confirm' | i18n }}"
                      nzCancelText="{{ 'common.cancel' | i18n }}"
                      (nzOnConfirm)="cleanContact(item)"
                      [testId]="'tenant-contact-clean-popconfirm-' + i"
                    >
                      <button
                        nz-button
                        nzType="link"
                        nzDanger
                        class="table-action-btn table-action-danger"
                        [disabled]="!item?.id"
                        [nzLoading]="cleaningId === item.id"
                        [testId]="'tenant-contact-clean-btn-' + i"
                      >
                        {{ 'tenant.contact.clean' | i18n }}
                      </button>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>

        <div class="mobile-card-section" testId="tenant-contact-mobile-section">
          <ng-container *ngIf="listOfData.length; else mobileEmpty">
            <div class="mobile-card-list">
              <div
                class="contact-card"
                *ngFor="let item of listOfData; let i = index; trackBy: trackByContact"
                [testId]="'tenant-contact-mobile-card-' + i"
              >
                <div class="contact-card-header">
                  <div class="contact-card-title-wrap">
                    <div class="contact-avatar">
                      <nz-avatar [nzSrc]="item.avatarUrl || item.fallbackAvatarUrl" nzShape="circle" [nzSize]="40" />
                    </div>
                    <div class="name-cell">
                      <div class="name">{{ getDisplayName(item) }}</div>
                      <div class="alias" *ngIf="item.alias && item.alias !== item.name">{{ item.alias }}</div>
                    </div>
                  </div>
                  <span class="status-pill" [ngClass]="getStatusPillClass(item.status)">{{ getStatusTextKey(item.status) | i18n }}</span>
                </div>

                <div class="contact-card-detail-rows">
                  <div class="detail-row">
                    <span class="detail-label">{{ 'tenant.contact.channel' | i18n }}：</span>
                    <span class="detail-value">
                      <span class="channel-pill">{{ item.channel || ('common.unknown' | i18n) }}</span>
                    </span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">{{ 'common.phone' | i18n }}：</span>
                    <span class="detail-value">{{ item.phone || '-' }}</span>
                  </div>
                </div>

                <div class="contact-card-actions">
                  <button
                    *ngIf="item?.id"
                    nz-button
                    nzType="default"
                    type="button"
                    class="card-action-btn card-action-view"
                    (click)="openDetail(item)"
                    [testId]="'tenant-contact-mobile-view-button-' + item.id"
                  >
                    <i nz-icon nzType="eye"></i>
                    {{ 'common.view' | i18n }}
                  </button>
                  <a
                    nz-popconfirm
                    nzPopconfirmTitle="{{ 'tenant.contact.clean.confirm' | i18n }}"
                    nzOkText="{{ 'common.confirm' | i18n }}"
                    nzCancelText="{{ 'common.cancel' | i18n }}"
                    (nzOnConfirm)="cleanContact(item)"
                    [testId]="'tenant-contact-mobile-clean-popconfirm-' + i"
                  >
                    <button
                      nz-button
                      nzType="default"
                      type="button"
                      class="card-action-btn card-action-danger"
                      [disabled]="!item?.id"
                      [nzLoading]="cleaningId === item.id"
                      [testId]="'tenant-contact-mobile-clean-button-' + item.id"
                    >
                      <i nz-icon nzType="delete"></i>
                      {{ 'tenant.contact.clean' | i18n }}
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div
              class="mobile-load-more-anchor"
              #mobileLoadMoreAnchor
              *ngIf="isMobileView && hasMoreMobile"
              testId="tenant-contact-mobile-load-anchor"
            ></div>
            <div class="mobile-load-more" *ngIf="isLoadingMore" testId="tenant-contact-mobile-loading-more">
              {{ 'common.loading' | i18n }}
            </div>
          </ng-container>
        </div>
      </nz-spin>
      <div class="content-footer" *ngIf="total > 0 && !isMobileView" testId="tenant-contact-content-footer">
        <div class="pagination-section pagination-container" testId="tenant-contact-pagination-section">
          <div class="pagination-info" testId="tenant-contact-pagination-summary">
            {{ 'common.total-records' | i18n: { total: total } }}
          </div>
          <div class="pagination-controls" testId="tenant-contact-pagination-controls">
            <nz-pagination
              nzSize="small"
              [nzPageIndex]="pageIndex"
              [nzTotal]="total"
              [nzPageSize]="pageSize"
              [nzPageSizeOptions]="[10, 20, 50, 100]"
              [nzShowQuickJumper]="false"
              [nzShowSizeChanger]="false"
              (nzPageIndexChange)="onPageIndexChange($event)"
              (nzPageSizeChange)="onPageSizeChange($event)"
              testId="tenant-contact-pagination"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #mobileEmpty>
  <div class="mobile-empty" testId="tenant-contact-mobile-empty">
    <nz-empty />
  </div>
</ng-template>

<tenant-contact-detail [visible]="detailVisible" [tenantId]="tenantId" [contact]="selectedContact" (close)="closeDetail()" />
